export enum Tab {
  Info = "info",
  GoodsAndWarehouse = "goodsAndWarehouse",
  Employees = "employees",
  Fee = "fee",
  Improvements = "improvements",
  Service = "service",
  PricesForServices = "pricesForServices",
  Safe = "safe",
  PurchaseHistory = "purchaseHistory",
}
